class MapLayer {
    /**
     * @param {string} url 
     * @param {L.GeoJSONOptions} options
     */
    constructor(url, options) {
        /** @type {GeoJSON.FeatureCollection} */
        this.geoJson = null;
        this.show = true;
        this.url = url;
        this.options = options;
    }

    async fetch() {
        const response = await fetch(this.url);
        const data = await response.json();
        this.geoJson = data;
    }
}

class MapLayerGroup {
    /**
     * @param {string} name 
     * @param {{color: string}} options
     * @param {{[name:string]: MapLayer}} layers 
     */
    constructor(name, options, layers) {
        this.name = name;
        this.color = options.color;
        this.layers = layers;
    }

    /**
     * @returns {boolean}
     */
    get show() {
        return Object.values(this.layers).some((layer) => layer.show);
    }

    /**
     * @param {boolean} value
     */
    set show(value) {
        Object.values(this.layers).forEach(layer => {
            layer.show = value;
        });
    }
}

export {
    MapLayer,
    MapLayerGroup
}